<template>
  <section class="discount">
    <div class="discount__add" v-if="isActive">
      <div class="discount__input">
        <input
          ref="discountCode"
          placeholder="Discount Code"
          type="text"
          v-model="code"
          v-on:keyup.enter="apply"
          :disabled="isApplied"
        />
        <small v-if="isApplied">
          <span v-if="isCheckingDB">Checking</span>
          <span v-else-if="discount">
            {{discount.label}} discount
          </span>
          <span v-else>Invalid discount code</span>
        </small>
      </div>
      <div class="discount__action">
        <a v-if="isApplied" @click="remove">Remove</a>
        <a @click="apply" v-else>Apply</a>
      </div>
    </div>
    <div class="discount__trigger" v-else>
      <a @click="show">Apply discount</a>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  code: 'Discount',
  props: {
    amount: Number,
    currency: String,
    value: Object,
  },
  data() {
    return {
      code: null,
      isActive: false,
      isCheckingDB: false,
      isApplied: false,
      isInvalid: false,
    };
  },
  watch: {
    code() {
      this.isInvalid = false;
      this.invalidCurrency = false;
    },
    discount() {
      this.emit();
    },
    isApplied() {
      this.emit();
    },
  },
  computed: {
    ...mapGetters(['getDiscount']),
    discount() {
      const { code, currency } = this;
      return this.getDiscount({ code, currency });
    },
  },
  methods: {
    ...mapActions(['fetchAllDiscounts']),
    show() {
      this.isActive = true;
      setTimeout(() => {
        this.$refs.discountCode.focus();
      }, 300);
    },
    apply() {
      this.isApplied = true;
      if (!this.discount) {
        this.isCheckingDB = true;
        this.fetchAllDiscounts().finally(() => {
          this.isCheckingDB = false;
        });
      }
    },
    remove() {
      this.isActive = false;
      this.isApplied = false;
      this.isInvalid = false;
      this.code = null;
      this.$emit('input', null);
    },
    emit() {
      let amount = this.discount && this.discount.value;
      if (amount && this.discount.type === 'percentage') {
        amount = this.discount.value * this.amount / 100;
      }
      const discount = this.isApplied ? {
        ...this.discount,
        amount,
      } : null;
      this.$emit('input', discount);
    },
  },
  created() {
    this.fetchAllDiscounts();
  },
};
</script>

<style lang="scss" scoped>
.discount {
  input {
    font-family: inherit;
    font-size: var(--font-p);
    border: none;
    background: none;
    outline: none;
    display: inline-block;
    width: auto;
  }
  &__add {
    display: flex;
    align-items: center;
  }
  &__input {
    flex: 1;
    input {
      display: block;
      margin: 0;
      &:disabled {
        pointer-events: none;
        color: var(--color-dark);
        opacity: 1;
      }
    }
  }
}
</style>
